import React, { useEffect, useState } from "react";
import location from "../../assets/images/icons/locationIcon.svg";
import Loader from "../loader/Loader";
import { FaCheckSquare, FaRegSquare, FaSquare } from "react-icons/fa";
import { Button } from "@mui/material";
import { toast } from "react-toastify";

const countryCodeMapping = [
  { "code": "+91", "value": "+91 India" }
]
const stateMapping = [
  { "code": "Noida", "value": "Noida" }
]

const countryMapping = [
  { "code": "India", "value": "India" }
]

function EditAddressNew({ setRefreshAddresses, addressId, setShowAddAddressForm }) {

  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [pincodeInfo, setPincodeInfo] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [stateInfo, setStateInfo] = useState("");
  const [countryInfo, setCountryInfo] = useState("India");
  const [districtInfo, setDistrictInfo] = useState("");
  const [emailInfo, setEmailInfo] = useState("");
  const [mobileInfo, setMobileInfo] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false)
  const [defaultAddress, setDefaultAddress] = useState(false)

  // error state 
  const [nameError, setNameError] = useState("");
  const [addressLine1Error, setAddressLine1Error] = useState("");
  const [addressLine2Error, setAddressLine2Error] = useState("");
  const [pincodeError, setPincodeError] = useState("");
  const [countryCodeError, setCountryCodeError] = useState("");
  const [stateError, setStateError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [districtError, setDistrictError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const cartContext = localStorage.getItem("cartContext");
  const customerId = localStorage.getItem("customerId");


  const apiUrl = `${process.env.REACT_APP_BACKEND_URL}customer/get-all-addresses/`;
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchPincodeDetails = async () => {
      if (pincodeInfo.length === 6) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_URL}api/pincodes?pincode=${pincodeInfo}`
          );
          const data = await response.json();

          if (data?.data) {
            setDistrictInfo(data.data.district);
            setStateInfo(data.data.statename);
            setPincodeError("");
          } else {
            setPincodeError("Invalid Pincode");
            setDistrictInfo("");
            setStateInfo("");
          }
        } catch (error) {
          console.error("Pincode API Error:", error);
          setPincodeError("Failed to fetch Pincode details");
          setDistrictInfo("");
          setStateInfo("");
        }
      }
    };

    const timeoutId = setTimeout(() => {
      if (pincodeInfo.length === 6) {
        fetchPincodeDetails();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [pincodeInfo]);


  // Fetch data when component mounts
  useEffect(() => {
    const fetchAddressData = async () => {

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "token": token,
          },
        });

        const result = await response.json();
        const matchingAddress = result?.addresses?.find((address) => address._id === addressId);

        if (matchingAddress) {
          // Populate form fields with existing data
          setName(matchingAddress.name);
          setAddressLine1(matchingAddress.addressLine1);
          setAddressLine2(matchingAddress.addressLine2);
          setPincodeInfo(matchingAddress.zip);
          setStateInfo(matchingAddress.state);
          setDistrictInfo(matchingAddress.district);
          setEmailInfo(matchingAddress.email);
          setMobileInfo(matchingAddress.mobile);
          setDefaultAddress(matchingAddress?.defaultAddress)
          setLoading(false); // Stop loading when data is fetched
        } else {
          console.error("Error fetching address data:", result);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error:", error);
        setLoading(false);
      }
    };

    fetchAddressData();
  }, [apiUrl, token, addressId]);


  // for validation 
  const validateFields = () => {
    let isValid = true;

    if (!name.trim()) {
      setNameError("Name is required");
      isValid = false;
    } else {
      setNameError("");
    }

    if (!addressLine1.trim()) {
      setAddressLine1Error("Address Line 1 is required");
      isValid = false;
    } else {
      setAddressLine1Error("");
    }
    if (!addressLine1.trim()) {
      setAddressLine2Error("Address Line 2 is required");
      isValid = false;
    } else {
      setAddressLine2Error("");
    }
    if (!countryCode.trim()) {
      setCountryCodeError("Country Code is required");
      isValid = false;
    } else {
      setCountryCodeError("");
    }

    if (!countryInfo.trim()) {
      setCountryError("Country is required");
      isValid = false;
    } else {
      setCountryError("");
    }

    if (!pincodeInfo.trim()) {
      setPincodeError("Pincode is required");
      isValid = false;
    } else if (!/^\d{6}$/.test(pincodeInfo)) {
      setPincodeError("Pincode should be 6 digits");
      isValid = false;
    } else {
      setPincodeError("");
    }

    if (!stateInfo.trim()) {
      setStateError("State is required");
      isValid = false;
    } else {
      setStateError("");
    }

    if (!districtInfo.trim()) {
      setDistrictError("district is required");
      isValid = false;
    } else {
      setDistrictError("");
    }

    if (!emailInfo.trim()) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInfo)) {
      setEmailError("Invalid email format");
      isValid = false;
    } else {
      setEmailError("");
    }

    if (!mobileInfo.trim()) {
      setMobileError("Mobile number is required");
      isValid = false;
    } else if (!/^\d{10}$/.test(mobileInfo)) {
      setMobileError("Mobile number should be 10 digits");
      isValid = false;
    } else {
      setMobileError("");
    }

    return isValid;
  };

const handleCancel = ()=>{
setShowAddAddressForm(false);
  }

  // update button submit handeller
  const handleSubmit = async () => {
    
    setLoading(true);
    const apiUrl = `${process.env.REACT_APP_BACKEND_URL}customer/edit-address/${addressId}`;
    const token = localStorage.getItem('token');
    if (!validateFields()) {
      setLoading(false)
      return;
    }
    const payload = {
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      zip: pincodeInfo,
      state: stateInfo,
      district: districtInfo,
      country: countryInfo,
      countryCode: countryCode,
      email: emailInfo,
      mobile: mobileInfo,
      name: name,
      defaultAddress: defaultAddress,
      cartContext: cartContext,
      customerId: customerId,
      token: token
    };

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "token": token
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (response.ok) {
        setLoading(false)
        if( result.token)
          {localStorage.setItem("token", result.token);}
          localStorage.setItem("customerId", result.userId);
          localStorage.setItem("usermob", result.mobile)
        setRefreshAddresses(prev => !prev);
        setShowAddAddressForm(false);
        toast.success("Address Updated successfully!",{autoClose:1000});

      } else {
        setLoading(false)
        console.error("Error add addressing:", result);
      }
    } catch (error) {
      setLoading(false)
      console.error("Error:", error);
    }
  };

  const clearForm = () => {
    setName("");
    setAddressLine1("");
    setAddressLine2("");
    setCountryCode("");
    setCountryInfo("")
    setPincodeInfo("");
    setStateInfo("");
    setDistrictInfo("");
    setEmailInfo("");
    setMobileInfo("");
  };



  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {loading && <Loader />}
      <form action="">
        <div className="row">
          <div className="col-md-6">
            <div className="form-grp">
              <label htmlFor="name">Name : </label>
              <input
                name="name"
                id="name" type="text" value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  if (e.target.value.trim()) setNameError("");
                }} className="form-control" placeholder="John Doe" />
              {nameError && <p style={{ fontSize: '12px' }} className="text-danger mb-0 ps-2">{nameError}</p>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-grp">
              <label htmlFor="email">Email : </label>
              <input id="email" type="text" className="form-control" value={emailInfo} placeholder="johndoe123@gmail.com" onChange={(e) => {
                setEmailInfo(e.target.value);
                if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value))
                  setEmailError("");
              }} />
              {emailError && (
                <p
                  style={{ fontSize: "12px" }}
                  className="text-danger mb-0 ps-2"
                >
                  {emailError}
                </p>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-grp">
              <label htmlFor="country-code">Country Code : </label>
              <select type="text" className="form-control" id="country-code" value={countryCode} onChange={(e) => setCountryCode(e.target.value)}>
                <option value={""}>select</option>
                {countryCodeMapping.map((mapping) => {
                  return (
                    <option key={mapping.code} value={mapping.code}>{mapping.value}</option>
                  );
                })}
              </select>
              {countryCodeError && (
                <p
                  style={{ fontSize: "12px" }}
                  className="text-danger mb-0 ps-2"
                >
                  {countryCodeError}
                </p>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-grp">
              <label htmlFor="mobile">Mobile no. : </label>
              <input id="mobile" type="text" className="form-control" placeholder="9876543210" value={mobileInfo}
                maxLength={10}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    setMobileInfo(value);
                    if (value.length === 10) {
                      setMobileError("");
                    }
                  }
                }} /> {mobileError && (
                  <p
                    style={{ fontSize: "12px" }}
                    className="text-danger mb-0 ps-2"
                  >
                    {mobileError}
                  </p>
                )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-grp">
              <label htmlFor="pin-code">Pincode : </label>
              <input type="text" id="pin-code" className="form-control" placeholder="000-000" value={pincodeInfo}
                maxLength={6}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,6}$/.test(value)) {
                    setPincodeInfo(value);
                  }
                }} /> {pincodeError && (
                  <p
                    style={{ fontSize: "12px" }}
                    className="text-danger mb-0 ps-2"
                  >
                    {pincodeError}
                  </p>
                )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-grp">
              <label htmlFor="district">District : </label>
              <input type="text" className="form-control" value={districtInfo}
                disabled placeholder="New Delhi" />
              {districtError && (
                <p
                  style={{ fontSize: "12px" }}
                  className="text-danger mb-0 ps-2"
                >
                  {districtError}
                </p>
              )}
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-grp">
              <label htmlFor="address-line-1">Address : </label>
              <input type="text" className="form-control" placeholder="Address line 1" value={addressLine1}
                onChange={(e) => {
                  setAddressLine1(e.target.value);
                  if (e.target.value.trim()) setAddressLine1Error("");
                }} /> {addressLine1Error && (
                  <p
                    style={{ fontSize: "12px" }}
                    className="text-danger mb-0 ps-2"
                  >
                    {addressLine1Error}
                  </p>
                )}
              <input type="text" className="form-control" placeholder="Address line 2 (Optional)" value={addressLine2}
                onChange={(e) => {
                  setAddressLine2(e.target.value);
                  if (e.target.value.trim()) setAddressLine2Error("");
                }} />
              {addressLine2Error && (
                <p
                  style={{ fontSize: "12px" }}
                  className="text-danger mb-0 ps-2"
                >
                  {addressLine2Error}
                </p>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-grp">
              <label htmlFor="state">State : </label>
              <input type="text" className="form-control" placeholder="Delhi" value={stateInfo}
                disabled /> {stateError && (
                  <p
                    style={{ fontSize: "12px" }}
                    className="text-danger mb-0 ps-2"
                  >
                    {stateError}
                  </p>
                )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-grp">
              <label htmlFor="country">Country : </label>
              <select id="country"
                value={countryInfo}
                className="form-control"
                onChange={(e) => {
                  setCountryInfo(e.target.value);
                  if (e.target.value.trim()) setCountryError("");
                }}>
                <option value={""}>select</option>
                {countryMapping.map((mapping) => {
                  return (
                    <option key={mapping.code} value={mapping.code}>{mapping.value}</option>
                  );
                })}
              </select>
              {countryError && (
                <p
                  style={{ fontSize: "12px" }}
                  className="text-danger mb-0 ps-2"
                >
                  {countryError}
                </p>
              )}
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-grp checkBox inner-flex">
              <div className="iconBox">{defaultAddress?<FaCheckSquare />:<FaRegSquare />}<input type="checkbox" id="defaultAddress" onChange={() => setDefaultAddress(prev => !prev)} checked={defaultAddress} /></div>
              <label htmlFor="defaultAddress"><span>Make this default address</span></label>
            </div>
          </div>
          <div className="col-md-12">
            <div className="btnBox">
              <Button className="btn button btn-2 theme-btn-2" onClick={handleSubmit} >Update Address
                {/* Update & Use this Address */}
              </Button>
              <Button className="btn button theme-btn" onClick={handleCancel}>Cancel</Button>
            </div>
          </div>
        </div>
      </form>


    </>
  );
}

export default EditAddressNew;
